module.exports = __webpack_public_path__ + "static/media/companyInfo.33d3c851.less";